import { render, staticRenderFns } from "./ChangeDisplayNameForm.vue?vue&type=template&id=6cae50a9&"
import script from "./ChangeDisplayNameForm.vue?vue&type=script&lang=js&"
export * from "./ChangeDisplayNameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports